<template>
  <div class="category-content">
    <el-menu default-active="category" class="el-menu-demo" mode="horizontal" :router="true">
      <el-menu-item index="list">竞赛管理</el-menu-item>
      <el-menu-item index="tag-manage" class="right">标签课程</el-menu-item>
      <el-menu-item index="category" class="right is-active">分类管理</el-menu-item>
    </el-menu>
    <div class="tab-item">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="比赛分类" name="first"></el-tab-pane>
        <el-tab-pane label="训练分类" name="second"></el-tab-pane>
        <el-tab-pane label="专题分类" name="third"></el-tab-pane>
      </el-tabs>
      <div class="add-box">
        <el-button type="primary" @click="addNode(courseGroupId,0)">添加分类</el-button>
      </div>
    </div>
    <template>
      <div class="custom-tree-container">
        <div class="custom-tree-header">
          <span class="header-item">分类名称</span>
          <span class="header-item">操作</span>
        </div>
        <el-tree :data="tableData" node-key="id" :props="{label:'name'}" :default-expand-all="true" draggable :allow-drop="allowDrop" :allow-drag="allowDrag"
          icon-class="el-icon-arrow-right" filters="{ghost-class:'ghostClass'}" @node-drop="dropEnd">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span class="custom-tree-title">{{ data.name }}</span>
            <span class="custom-tree-operation" @click.stop>
              <el-button size="mini" @click="editNode(node,data)">重命名</el-button>
              <el-button size="mini" @click="()=>deleteNode(node,data)">删除</el-button>
              <el-button size="mini" v-if="node.level!==3" @click="addNode(data.groupId,data.id)">添加子分类</el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </template>
    <el-dialog title="添加分类" width="600px" :visible.sync="dialogCategoryVisible" :close-on-click-modal="false" :before-close="cancelCategory">
      <el-form :model="categoryObj" ref="categoryForm" :rules="categoryRules" label-width="100px" @submit.native.prevent>
        <el-form-item label="分类名称" prop="name">
          <el-input v-model.trim="categoryObj.name" placeholder="请输入分类名称" autocomplete="off" autofocus="true"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button type="primary" @click="addCategory">确定</el-button>
        <el-button @click="cancelCategory">取消</el-button>
      </template>
    </el-dialog>
    <el-dialog title="编辑分类" width="600px" :visible.sync="dialogEditVisible" :close-on-click-modal="false" :before-close="cancelCategory">
      <el-form :model="categoryObj" ref="categoryForm" :rules="categoryRules" label-width="100px" @submit.native.prevent>
        <el-form-item label="分类名称" prop="name">
          <el-input v-model.trim="categoryObj.name" placeholder="请输入分类名称" autocomplete="off" autofocus="true"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button type="primary" @click="editCategory">确定</el-button>
        <el-button @click="cancelCategory">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getCategoryData, deleteCategory, checkCategory, addCategory, editCategory, sortCategory } from "@/api/course";
import qs from "qs";
export default {
  components: {
  },
  data() {
    var categoryValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入分类名称"));
      }
      if (value.length > 20) {
        return callback(new Error("名称的长度必须小于或等于100"));
      }
      let params = {
        groupId: this.courseGroupId,
        exclude: this.tempName,
        value: value
      };
      checkCategory(params).then(response => {
        if (!response.data.success) {
          callback(new Error("分类已存在"));
        } else {
          callback();
        }
      });
    };
    return {
      activeName: "first",
      dialogCategoryVisible: false,
      dialogEditVisible: false,
      categoryObj: {
        id: "",
        name: "",
        groupId: "",
        parentId: "",
        code: ""
      },
      categoryRules: {
        name: [
          { required: true, validator: categoryValidator, trigger: "blur" }
        ]
      },
      defaultProp: { children: "children", label: "name" },
      tableData: [],
      tempName: "", //临时名称
      courseGroupId: '',//分类的groupId
      defaultExpandKeys: [],
    };
  },
  watch: {
    activeName: function () {
      this.defaultExpandKeys = []
      this.courseGroupId = ''
      this.getCategoryData();
    }
  },
  mounted() {
    this.getCategoryData();
  },
  methods: {
    //获取分类数据
    getCategoryData: function () {
      this.tableData = [];
      let type = "";
      if (this.activeName === "first") {
        type = "course";
      } else if (this.activeName === "second") {
        type = "training";
      } else if (this.activeName === "third") {
        type = "classroom";
      } else {
        type = "course";
      }
      getCategoryData(type).then(response => {
        this.tableData = response.data.categories;
        this.courseGroupId = response.data.group.id;
      });
    },
    //添加分类
    addNode: function (groupId, parentId) {
      this.dialogCategoryVisible = true;
      this.categoryObj.groupId = groupId;
      this.categoryObj.parentId = parentId;
    },
    //编辑分类
    editNode: function (node, data) {
      this.dialogEditVisible = true;
      this.tempName = data.name;
      this.categoryObj = {
        id: data.id,
        name: data.name,
        groupId: data.groupId,
        parentId: data.parentId,
        code: data.code,
      };
    },
    //添加保存分类
    addCategory: function () {
      this.$refs["categoryForm"].validate(valid => {
        if (valid) {
          let params = {
            name: this.categoryObj.name,
            groupId: this.categoryObj.groupId,
            parentId: this.categoryObj.parentId,
            code: '',
            description: '',
            icon: '',
          }
          addCategory(qs.stringify(params)).then(response => {
            this.cancelCategory()
            this.tableData = response.data.categories
            this.$message.success('添加成功')
          })
        }
      });
    },
    //编辑保存分类
    editCategory: function () {
      this.$refs["categoryForm"].validate(valid => {
        if (valid) {
          let params = {
            name: this.categoryObj.name,
            groupId: this.categoryObj.groupId,
            parentId: this.categoryObj.parentId,
            code: this.categoryObj.code,
            description: '',
            icon: '',
          }
          editCategory(this.categoryObj.id, qs.stringify(params)).then(response => {
            this.cancelCategory()
            this.tableData = response.data.categories
            this.$message.success('编辑成功')
          })
        }
      });
    },
    //删除分类
    deleteNode: function (node, data) {
      this.$confirm("真的要删除该分类吗？", "删除分类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteCategory(data.id).then(response => {
          const parent = node.parent;
          const children = parent.data.children || parent.data;
          const index = children.findIndex(d => d.id === data.id);
          children.splice(index, 1);
          this.$message.success('删除成功')
        });
      })
        .catch(() => { });
    },
    //关闭弹窗
    cancelCategory: function () {
      this.dialogCategoryVisible = false;
      this.dialogEditVisible = false;
      this.$refs.categoryForm.resetFields();
      this.categoryObj = {
        id: "",
        name: "",
        groupId: "",
        parentId: "",
        code: ''
      };
      this.tempName = ""
    },
    //判断拖拽是否允许放置
    allowDrop: function (draggingNode, dropNode, type) {
      let dragParentKey = draggingNode.parent.key
      let dropParentKey = dropNode.parent.key
      let dragLevel = draggingNode.data.level
      let dropLevel = dropNode.data.level
      if (dragParentKey !== dropParentKey) {
        return false
      } else {
        if (dragLevel !== dropLevel) {
          return false
        } else {
          if (type === 'inner') {
            return false
          }
          return true
        }
      }
    },
    //判断是否允许拖拽
    allowDrag: function (draggingNode) {
      return true;
    },
    //点击节点
    handleNodeClick: function (nodes, node, self) {
      let key = node.key
      if (node.level !== 3) {
        let index = this.defaultExpandKeys.findIndex((val) => {
          return val === key
        })
        if (index === -1) {
          this.defaultExpandKeys.push(node.key);
        } else {
          this.defaultExpandKeys.splice(index, 1)
        }
      }
    },
    //拖拽完成
    dropEnd: function (draggingNode, dropNode, dropType, ev) {
      let parentId = dropNode.data.parentId
      let ids = []
      if (parentId === '0') {
        this.tableData.forEach(element => {
          ids.push(element.id)
        });
      } else {
        let childs = dropNode.parent.childNodes
        childs.forEach(element => {
          ids.push(element.data.id)
        })
      }
      let params = {
        ids: ids
      }
      sortCategory(qs.stringify(params)).then(response => {

      })

    }
  }
};
</script>

<style scoped>
.category-content {
  background-color: #ffffff;
  padding: 20px;
  overflow: auto;
}
.category-content .el-menu {
  margin-bottom: 15px;
}
.category-content .custom-tree-header {
  height: 45px;
  line-height: 45px;
  background-color: #f2f2f2;
}
.category-content .custom-tree-header .header-item {
  line-height: 45px;
  height: 45px;
  display: inline-block;
}
.category-content .custom-tree-header .header-item:first-child {
  padding-left: 15px;
  box-sizing: border-box;
  width: calc(100% - 150px);
}
.category-content .custom-tree-header .header-item:last-child {
  float: right;
  text-align: center;
  width: 150px;
}
.category-content .custom-tree-container >>> .el-tree-node__content {
  height: 40px;
  line-height: 40px;
  border-top: 1px solid #dce1e6;
  cursor: grab;
}
.category-content .custom-tree-container .custom-tree-node {
  width: 100%;
  display: inline-block;
}
.category-content .custom-tree-container .custom-tree-title {
  display: inline-block;
  cursor: pointer;
}
.category-content .custom-tree-container .custom-tree-operation {
  display: inline-block;
  width: 250px;
  text-align: left;
  float: right;
}
.category-content .tab-item {
  position: relative;
}
.category-content .add-box {
  position: absolute;
  top: -5px;
  right: 0;
}
.ghostClass {
  background-color: beige;
}
</style>
